import { render, staticRenderFns } from "./MeusCursosHomeCarousel.vue?vue&type=template&id=52868f72&scoped=true&"
import script from "./MeusCursosHomeCarousel.vue?vue&type=script&lang=js&"
export * from "./MeusCursosHomeCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52868f72",
  null
  
)

export default component.exports